<article class="login-page text-center">
    <form class="form-signin" (ngSubmit)="login()" [formGroup]="loginForm">
        <!-- Login Page Banner -->
        <!-- This can be Customize later -->
        <img id="zsd_login_banner" class="mb-3"  *ngIf="imageLoaded"  height="100" width="240" src= {{loginBannerSrc}} alt="">

          <!-- Login Page : String -->
          <div id="loginLegend" 
          [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(loginLegend)">
         </div>
        
       <div id="loginPage_Container">

        <!-- Login Page - User Name -->
         <input type="text" id="zsd_login_username" class="form-control zsd_placeholder"  placeholder="{{ 'Login.username' | translate}}" value="" 
         formControlName="username" (focus)="usernameFocus = true" (blur)="usernameFocus = false; checkOauthUser();" aria-label="Username" autocomplete="off" 
         autocorrect="off" autocapitalize="off" autofocus [ngStyle]="{'pointer-events': isLoginLoading ? 'none' : 'all' }">
                
        <!-- Login Page - Password -->
        <input *ngIf='!oauth_user' type="password" name="password" id="zsd_login_password"  class="form-control zsd_placeholder"  placeholder="{{ 'Login.password' | translate}}" value="" 
          formControlName="password" (focus)="passwordFocus = true" (blur)="passwordFocus = false" aria-label="Password" autocomplete="off"
          autocorrect="off" autocapitalize="off" [ngStyle]="{'pointer-events': isLoginLoading ? 'none' : 'all' }">
               
        <!-- Login Page - Domain -->
        <select class="custom-select" formControlName="domain" id="zsd_login_domain" *ngIf="!oauth_user && ldapDomains.resultCount > 1"
            [ngStyle]="{'pointer-events': isLoginLoading ? 'none' : 'all' }">
            <option *ngFor="let domain of ldapDomains.results; let i = index;trackBy:trackByldap" value="{{domain.ldapSourceId}}" 
            data-toggle="tooltip" data-placement="left"title={{domain.ldapSourceName}}>
                <p *ngIf="domain.ldapSourceName.length < 36; else elseBlock" >{{ domain.ldapSourceName }}</p>
                <ng-template #elseBlock >
                    <p>{{ domain.ldapSourceName.slice(0,35)+'...' }}  </p>
                </ng-template>
            </option>
        </select>

        <!-- Domain field gets displayed if count is more than one -->
        <input type="hidden" formControlName="domain" [ngModel]="ldapDomains.results[0].ldapSourceId" *ngIf="ldapDomains.resultCount === 1">

        </div>
          <!-- Error Message for User Name Required & Password required -->
        <div *ngIf="(!loginForm.controls['username'].valid && !usernameFocus) || (!loginForm.controls['password'].valid && !passwordFocus)" class="mt-2 mb-2 ml-1 text-white text-left" id="zsd_login_error_message">
                    {{ 'Login.usernamePasswordRequiredError' | translate }}
                </div>
                
         <!-- Login Page - Server Side Error Message -->                   
        <div *ngIf="loginErrorMessage!=null" class="mt-2 mb-2 ml-1 text-white text-left" id="zsd_login_error_message">
            {{loginErrorMessage}}
        </div>            
    
        <!-- SignIn Button -->
        <button *ngIf='!oauth_user; else OAuthUserBlock' [ngStyle]="{'pointer-events': isLoginLoading ? 'none' : 'all' }" 
        type="submit" id="zsd_login_sign_in" class="btn btn-sm btn-block text-white mt-3 btn-primary" aria-label="Login">{{ 'Login.signIn' | translate }}</button>
        <ng-template #OAuthUserBlock>
        <button [ngStyle]="{'pointer-events': isLoginLoading ? 'none' : 'all' }" 
        type="submit" id="zsd_login_sign_in" class="btn btn-sm btn-block text-white mt-3 btn-primary" aria-label="Login">Login with {{providerDisplayName}}</button>    
        </ng-template>                    
        <!-- SSPR Link -->
        <div class="row">
            <div class="col-12 zsd_login_sspr_container">
                <span *ngIf="isSSPRActive()">
                    <a href="{{sspr.ssprLink}}" id="zsd_login_forgot_password" target="_blank" class="text-white mt-4 float-right">{{ 'Login.passwordSelfService' | translate }}</a>
                </span>                
                <zsd-spinner class="zsd_login_spinner"></zsd-spinner>
            </div>
        </div>
    
        <!-- Copy Right Message -->
            <p class="mb-2 text-white float-left copyright" [ngClass]="{'pt-3' : isLoginLoading && !isSSPRActive() }" id="zsd_login_copyrightMsg">{{ 'Login.copyrightMsg' | translate }} {{ 'Login.copyrightMsgArr' | translate }}</p>
  </form>
</article>

